import { FormControlLabel, Checkbox, Tooltip } from "@mui/material"
import { QUESTION_DIMENSIONABLE_KEY } from "../../../../constants/wizardConstants"
import { useContextAuth } from "../../../../authContext/AuthHook";

export const DimensionableQuestion = ({ dimensionable, answerQuestion }) => {
    const { user } = useContextAuth();

    return (
        <>
            <FormControlLabel
                control={
                    <Tooltip arrow title={user?.isAnonymous === true || user?.isInternal !== true ? "Enbart shuntgruppstyper som är dimensionerbara i ShuntLogik är för närvarande inkluderade i filtreringen" : ""}>
                        <span>
                            <Checkbox
                                disabled={user?.isAnonymous === true || user?.isInternal !== true}
                                checked={dimensionable}
                                onChange={() => answerQuestion(QUESTION_DIMENSIONABLE_KEY, !dimensionable)}
                            />
                        </span>
                    </Tooltip>
                }
                label="Dimensionerbar i ShuntLogik"
            />
        </>
    );
}